import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=9710d2e6"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollapse.vue?vue&type=style&index=0&id=9710d2e6&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9710d2e6')) {
      api.createRecord('9710d2e6', component.options)
    } else {
      api.reload('9710d2e6', component.options)
    }
    module.hot.accept("./SimpleCollapse.vue?vue&type=template&id=9710d2e6", function () {
      api.rerender('9710d2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/SimpleCollapse.vue"
export default component.exports